/* eslint-disable quotes */
/* eslint-disable semi */
import { storeGetters } from  '../../getters.constants';

const getters = {
 
  [storeGetters.getLicenseManagers]: (state) => {
    return state.licenseManagers;
  },
  [storeGetters.getRoleList]: (state) => {
    return state.roleList;
  },
};
export default { ...getters };
